import tinymce from 'tinymce/tinymce';
import 'tinymce/plugins/code';
import 'tinymce/plugins/link';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/preview';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

tinymce.init({
    selector: '.tinymce',
    plugins: ['code', 'advlist', 'lists', 'link', 'table', 'fullscreen', 'preview'],
    toolbar: 'undo redo | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlst checklist outdent indent | removeformat | code table help'
});
